"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _data = require("../stores/data");
var _editor = require("../utils/editor");
var _Field = _interopRequireDefault(require("./Field"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var propTypes = {
  name: _propTypes["default"].string.isRequired,
  fields: _propTypes["default"].object.isRequired,
  renderItem: _propTypes["default"].func,
  limit: _propTypes["default"].number,
  sizes: _propTypes["default"].Object
};
function Collection(props, ref) {
  var name = props.name,
    children = props.children,
    renderItem = props.renderItem,
    fields = props.fields,
    limit = props.limit;
  var _useData = (0, _data.useData)(),
    setCollection = _useData.setCollection,
    getCollectionItems = _useData.getCollectionItems,
    getFieldValue = _useData.getFieldValue,
    setFieldType = _useData.setFieldType;
  setCollection(name, {
    fields: fields,
    limit: limit
  });
  var items = getCollectionItems(name);
  function render() {
    var elProps = (0, _omit["default"])(props, Object.keys(propTypes));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread(_objectSpread({}, elProps), getEditProps()), {}, {
      ref: ref,
      children: renderItems()
    }));
  }
  function renderItems() {
    if (!items.length) {
      return 'No Items';
    }
    var mapped = items.map(function (item, i) {
      var renderProps = (0, _mapValues["default"])(item, function (field, key) {
        var name = field.name;
        var type = fields[key];
        setFieldType(name, type);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Field["default"], {
          name: name,
          type: type
        });
      });
      var data = (0, _mapValues["default"])(item, function (field) {
        var name = field.name;
        return getFieldValue(name);
      });
      data = _objectSpread(_objectSpread({}, data), {}, {
        index: i,
        number: i + 1
      });
      return [renderProps, data];
    });
    if (typeof children === 'function') {
      return children(mapped);
    } else if (typeof renderItem === 'function') {
      return mapped.map(function (mapped, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react["default"].Fragment, {
          children: renderItem.apply(void 0, _toConsumableArray(mapped))
        }, i);
      });
    } else {
      throw new Error('Collection component requires renderItem or children as a function.');
    }
  }
  function getEditProps() {
    if ((0, _editor.canEdit)()) {
      return {
        'data-collection-name': name
      };
    }
  }
  return render();
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(Collection);